export default __webpack_public_path__ + "static/media/whiskeypedia_logo_white.acf3ce45.png";